<div class="widget-aboutus widget">
    <h4 class="widget__title">About Blog</h4>
    <div class="widget-aboutus__text">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed tincidunt, erat in malesuada aliquam, est erat faucibus purus,
        eget viverra nulla sem vitae neque. Quisque id sodales libero.
    </div>

    <app-social-links class="widget-aboutus__socials" shape="rounded"></app-social-links>
</div>
